import { forwardRef, PropsWithChildren } from 'react';
import cn from 'classnames';

import s from './cta.module.scss';

type ButtonProps = {
  className?: string;
  variant?: 'white' | 'gray' | 'black';
  arrow?: 'bottom' | 'right';
  onClick?: () => void;
};

export const CTA = forwardRef<HTMLButtonElement, PropsWithChildren<ButtonProps>>(
  ({ children, className, variant = 'white', arrow, onClick }, ref) => {
    return (
      <button
        ref={ref}
        onClick={onClick}
        className={cn(s.cta, s[`cta__${variant}`], arrow && s['cta--arrowed'], className)}
      >
        {children}
        {arrow && (
          <span className={s[`cta__arrow--${arrow}`]}>
            {arrow === 'bottom' ? <ArrowBottom /> : <ArrowRight />}
          </span>
        )}
      </button>
    );
  }
);

const ArrowRight = () => (
  <svg className={s.arrow} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 12h14M12.5 5l7 7-7 7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowBottom = () => (
  <svg className={s.arrow} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 5v14M19 12l-7 7-7-7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
